import { Button, Input, Table, Select } from "antd";
import React, { useState, useRef } from "react";
import ExpandedRowRender2 from "./ExpanededSecondRow";
import { Form, Popconfirm, Row, Col, Tooltip } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { setFirstTable } from "../../../store/slices/firstTable";
import {
  DeleteTwoTone,
  CheckOutlined,
  PlusCircleOutlined,
  MinusOutlined,
  PlusOutlined,
  CheckCircleFilled,
  CloseOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import Axios from "../../../api/Axios";
import { getUpdateStatus } from "../ViewUpdateIndex";
import "./modalstyles.css";
import EditableImage from "../../icons/EditIcon";
import { capitalizeWords } from "../../icons/ApplicationColor";
const { Option } = Select;
const ExpanedFirstRow = ({
  record,
  index,
  closed,
  newProductRowIndex,
  setNewProductRowIndex,
  data,
  CreateSuccessfull,
  CreateFailed,
  entityID,
  manager,
  managerL3,
  active,
  modalVisible,
  setModalVisible,
  selectedRecord,
  setSelectedRecord,
  level,
  setLevel,
}) => {
  //console.log(manager, "-----------------------");
  // eslint-disable-next-line no-unused-vars
  const [category, setCategory] = useState([]);
  //console.log(index);
  console.log(data);
  const dispatch = useDispatch();
  const newProductRowIndex1 = useSelector((state) => state.firstTable);
  //console.log(newProductRowIndex1);
  // const [modalVisible, setModalVisible] = useState(false);
  // const [selectedRecord, setSelectedRecord] = useState(null);
  // const [newProductRowIndex, setNewProductRowIndex] = useState([
  //   false,
  //   false,
  //   false,
  //   false,
  // ]);
  // useEffect(() => {
  //   setNewProductRowIndex((prevState) => {
  //     const updatedState = [...prevState];
  //     updatedState[index] = true;
  //     return updatedState;
  //   });
  // }, []);
  // const [newProductRowIndex, setNewProductRowIndex] = useState(-1);
  //   console.log(closed);
  //   console.log(index);
  //   useEffect(() => {
  //     console.log(closed[index]);
  //     if (closed[index]) {
  //       console.log("+++++++++++++++++++++++++++++++");
  //       setNewProductRowIndex(-1);
  //     }
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [closed[index]]);
  const userInfo = useSelector((state) => state.user);
  const updateAuth = getUpdateStatus(userInfo, 0, 4);
  //console.log(newProductRowIndex);

  //console.log(index);
  const namingData = useSelector((state) => state.orgdeatil);
  //console.log(namingData);
  const deleteRecord = (record) => {
    if (record.user_count === 0 && record.department_count === 0) {
      onDelete(record);
    } else {
      setSelectedRecord(record);
      setLevel("level2");
      setModalVisible(true);
    }
  };
  const restoreRecord = (record) => {
    onRestore(record);
  };
  const onDelete = async (record) => {
    //console.log("In delete in expanded first row")
    const data = {
      status: false,
      entity: record.entity_level,
      div_level: record.div_level,
      updated_by: userInfo?.data?.id,
    };
    try {
      await Axios.put(`/division/${record.id}/`, data, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      cancel();
      CreateSuccessfull("Division level has been Archived");
    } catch (err) {
      //console.log(err);
      CreateFailed(
        err?.response?.data?.detail || "Division level has not been Archived"
      );
    }
  };
  const onRestore = async (record) => {
    const data = {
      status: true,
      entity: entityID,
      div_level: record.div_level,
      updated_by: userInfo?.data?.id,
    };
    try {
      await Axios.put(`/division/${record.id}/`, data, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      cancel();
      CreateSuccessfull("Division level has been Restored");
    } catch (err) {
      //console.log(err);
      CreateFailed(
        err?.response?.data?.detail || "Division level has not been Restored"
      );
    }
  };
  const onFinish21 = async (values) => {
    const row = await form.validateFields();
    row.entity = entityID;
    row.div_level = values.div_level;
    row.updated_by = userInfo?.data?.id;
    for (const key in row) {
      if (row.hasOwnProperty(key) && row[key] === "none") {
        row[key] = ""; // Replace "none" with an empty string
      }
    }

    try {
      await Axios.put(`/division/${values.id}/`, row, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      cancel();
      CreateSuccessfull("Division level has been edited");
    } catch (err) {
      //console.log(err);
      CreateFailed(
        err?.response?.data?.detail || "Division level has not been edited"
      );
    }
    //console.log(row);
    //console.log(values);
  };
  const columns = [
    {
      title: "HIERARCY NAME",
      dataIndex: "div_name",
      key: "div_name",
      width: 148, // set width to 150px
      editable: true,
      render: (text) => {
        // Render logic for the manager column
        return (
          <div
            style={{ padding: "8px", paddingLeft: "30px", fontSize: "13.5px" }}
          >
            {text}
          </div>
        );
      },
    },
    {
      title: "LEVEL",
      dataIndex: "div_level",
      key: "div_level",
      width: 149, // set width to 150px
      render: (text) => {
        return <div style={{ padding: "8px", fontSize: "13.5px" }}>{text}</div>;
      },
    },
    {
      title: "HIERARCY ID",
      dataIndex: "div_id",
      key: "div_id",
      width: 148, // set width to 150px
      editable: true,
      render: (text) => {
        return <div style={{ padding: "7px", fontSize: "13.5px" }}>{text}</div>;
      },
    },
    {
      title: "STRUCTURES",
      dataIndex: "department_count",
      key: "department_count",
      width: 99, // set width to 150px
      align: "center",
      render: (text) => {
        return <div style={{ padding: "7px", fontSize: "13.5px" }}>{text}</div>;
      },
    },
    {
      title: "USERS",
      dataIndex: "user_count",
      key: "user_count",
      width: 79, // set width to 150px
      align: "center",
      render: (text) => {
        return <div style={{ padding: "7px", fontSize: "13.5px" }}>{text}</div>;
      },
    },
    {
      title: "MANAGER",
      dataIndex: "manager",
      key: "manager",
      width: 149, // set width to 150px
      editable: true,
      render: (text, record) => {
        // Render logic for the manager column
        return (
          <div style={{ padding: "7px", fontSize: "13.5px" }}>
            {record?.manager?.full_name}
          </div>
        );
      },
    },
    {
      title: "ACTION",
      dataIndex: "operation",
      width: 79, // set width to 150px
      align: "center",
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <div>
            {active && (
              <CheckCircleFilled
                title="submit"
                style={{
                  color: "#52c41a",
                  fontSize: "1.8rem",
                  fontWeight: "700",
                }}
                onClick={() => onFinish21(record)}
              />
            )}

            <Popconfirm
              title={active ? "Confirm to Deactivate" : "Confirm to Restore"}
              onConfirm={() => {
                active ? deleteRecord(record) : restoreRecord(record);
              }}
            >
              {active ? (
                <>
                  {record?.can_be_deleted ? (
                    <DeleteTwoTone
                      style={{
                        cursor: "pointer",
                        fontSize: "1.8rem",
                        marginLeft: "0.9rem",
                      }}
                      title="delete"
                      twoToneColor="#eb2f96"
                      onClick={() => {
                        // setNewProduct(false);
                        // handleReset();
                      }}
                    />
                  ) : null}
                </>
              ) : (
                <>
                  <SwapOutlined
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8rem",
                      marginLeft: "0.9rem",
                    }}
                    // onClick={() => {
                    //   handleDelete(record);
                    // }}
                    title="Restore"
                  />
                </>
              )}
            </Popconfirm>
            <CloseOutlined
              onClick={() => {
                cancel();
              }}
              style={{
                cursor: "pointer",
                fontSize: "1.8rem",
                marginLeft: "0.9rem",
              }}
            />
          </div>
        ) : record?.update?.edit ? (
          <>
            <Tooltip title={`EDIT - ${record?.div_level}`}>
              <div>
                <EditableImage
                  handleRowClick={handleRowClick}
                  recordId={record}
                  disabled={editingKey !== ""}
                />
              </div>
            </Tooltip>
          </>
        ) : null;
      },
    },
  ];

  // for (let i = 0; i < 2; ++i) {
  //   data.push({
  //     key: i.toString(),
  //     name: "Screen",
  //     platform: "iOS",
  //     version: "10.3.4.5654",
  //     upgradeNum: 500,
  //     creator: "Jack",
  //     createdAt: "2014-12-24 23:12:00",
  //   });
  // }

  //
  const [editingKey, setEditingKey] = useState("");
  const [initialHirearchy, setInitialHirearchy] = useState("");

  const isEditing = (record) => record.id === editingKey;
  const edit = (record) => {
    form.setFieldsValue({
      ...record,
      manager: record?.manager?.id,
    });
    setEditingKey(record.id);
    setInitialHirearchy(record?.div_id);
  };
  const cancel = () => {
    setEditingKey("");
  };
  // eslint-disable-next-line no-unused-vars
  const [applications, setApplications] = useState([]);
  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const inputNode =
      inputType === "select" ? (
        <Select placeholder="Select Manager" disabled={!active}>
          <Option key={"null"} value={"none"}>
            None
          </Option>
          {manager?.map((app) => (
            <Option key={app.id} value={app.id}>
              {app.full_name}
            </Option>
          ))}
        </Select>
      ) : (
        <Input disabled={!active} />
      );

    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{
              margin: 0,
            }}
            rules={
              dataIndex === "div_id"
                ? [
                    {
                      validator: checkUserExists2,
                      validateTrigger: "onChange",
                    },
                  ]
                : dataIndex !== "manager"
                ? [
                    {
                      required: true,
                      message: `Please Input ${title}!`,
                    },
                  ]
                : undefined
            }
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  // eslint-disable-next-line no-unused-vars
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const [form1] = Form.useForm();
  const [isUserExists2, setIsUserExists2] = useState(false);
  const handleFormChange2 = async (changedValues, allValues) => {
    //console.log(changedValues, allValues);
    if ("div_id" in changedValues && allValues.div_id.length > 0) {
      if (allValues.div_id === initialHirearchy) {
        setIsUserExists2(false);
      } else {
        const response = await Axios.get(
          `/orgstructurecheck/${userInfo.data.organization.id}/?hierarchy=Level1&search=${allValues.div_id}`
        );
        //console.log(response);
        setIsUserExists2(response.data.exists);
        //console.log(isUserExists2);
      }
    } else {
      setIsUserExists2(false);
    }
  };
  const checkUserExists2 = () => {
    return new Promise(async (resolve, reject) => {
      if (isUserExists2 === undefined) {
        // API call has not completed yet, wait for it to complete and try again
        setTimeout(() => {
          checkUserExists2().then(resolve, reject);
        }, 100);
      } else if (isUserExists2) {
        reject("Client already exists");
      } else {
        resolve();
      }
    });
  };

  const [isUserExists, setIsUserExists] = useState(false);
  const handleFormChange = async (changedValues, allValues) => {
    //console.log(changedValues);
    if ("div_id" in changedValues && allValues.div_id.length > 0) {
      const response = await Axios.get(
        `/orgstructurecheck/${userInfo.data.organization.id}/?hierarchy=Level2&search=${allValues.div_id}`
      );
      //console.log(response);
      setIsUserExists(response.data.exists);
      //console.log(isUserExists);
    }
  };
  const checkUserExists = () => {
    return new Promise(async (resolve, reject) => {
      if (isUserExists === undefined) {
        // API call has not completed yet, wait for it to complete and try again
        setTimeout(() => {
          checkUserExists().then(resolve, reject);
        }, 100);
      } else if (isUserExists) {
        reject("Client already exists");
      } else {
        resolve();
      }
    });
  };
  const formRef = useRef();
  const handleReset = () => {
    formRef.current.resetFields();
  };
  const csrfToken = getCookie("csrftoken");
  const onFinish2 = async (values) => {
    //console.log(values);
    for (const key in values) {
      if (values.hasOwnProperty(key)) {
        // Check if the value is undefined
        if (values[key] === undefined) {
          // Update undefined value to null
          values[key] = null;
        }
      }
    }
    values.entity = entityID;
    values.created_by = userInfo?.data?.id;
    try {
      await Axios.post("/divisioncreate/", values, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);

      handleReset();
      CreateSuccessfull("Division level has been created");
    } catch (err) {
      //console.log(err);
      CreateFailed(
        err?.response?.data?.detail || "Division level has not been created"
      );
    }
  };
  const handleRowClick = (record) => {
    // Navigate to the details page using React Router
    edit(record);
  };
  const [form] = Form.useForm();
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === "manager" ? "select" : "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  const expandIcon = ({ expanded, onExpand, record }) =>
    expanded ? (
      <MinusOutlined
        onClick={(e) => onExpand(record, e)}
        style={{ color: "gray" }}
      />
    ) : (
      <PlusOutlined
        onClick={(e) => onExpand(record, e)}
        style={{ color: "gray" }}
      />
    );
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  return (
    <>
      <Form
        form={form}
        component={false}
        onValuesChange={handleFormChange2}
        style={{ margin: 0, padding: 0 }}
      >
        <Table
          columns={mergedColumns}
          dataSource={data}
          components={{
            body: {
              cell: EditableCell,
            },
          }}
          bordered
          expandable={{
            expandIcon,
            onExpand: (expanded, record) => {
              setExpandedRowKeys((prevKeys) => {
                if (expanded) {
                  return [...prevKeys, record.id];
                } else {
                  return prevKeys.filter((key) => key !== record.id);
                }
              });
            },
          }}
          rowKey="id"
          rowClassName={(record, index) =>
            expandedRowKeys.includes(record.id)
              ? "editable-row expanded-row-table-row-2"
              : "editable-row expanded-row-table-row-2"
          }
          pagination={false}
          showHeader={false}
          className="expanded-row-table-row-2"
          style={{ margin: 0, padding: 0 }}
          expandedRowRender={(record, index) => {
            return (
              <ExpandedRowRender2
                record={record}
                index={index}
                // hhh={hhh}
                // setHH={setHH}
                // mainIndex={index}
                data={data[index]?.department}
                divisonId={data[index].id}
                CreateFailed={CreateFailed}
                CreateSuccessfull={CreateSuccessfull}
                manager={managerL3}
                active={active}
                modalVisible={modalVisible}
                setModalVisible={setModalVisible}
                selectedRecord={selectedRecord}
                setSelectedRecord={setSelectedRecord}
                level={level}
                setLevel={setLevel}
              />
            );
          }}
        />
      </Form>
      {/* {!stateManage && ( */}
      {!newProductRowIndex1[index] &&
        updateAuth &&
        active &&
        (data.length === 0 || data?.[0]?.update?.add) && (
          <Button
            onClick={() => {
              // setNewProductRowIndex(index);
              //console.log(index);
              dispatch(setFirstTable({ index: index, value: true }));
            }}
            style={{
              background: "white",
              fontWeight: "500",
              fontSize: "1.35rem",
              marginLeft: "11rem",
              marginTop: "1rem",
              marginBottom: "1rem",
            }}
          >
            <PlusCircleOutlined style={{ color: "blue" }} />
            {capitalizeWords(data?.[0]?.div_label) || "Add"}
          </Button>
        )}
      {/* {stateManage && ( */}
      {newProductRowIndex1[index] && (
        <div
          style={{
            marginLeft: "7rem",
            marginBottom: "2rem",
            width: "100%",
          }}
        >
          <Form
            onFinish={onFinish2}
            ref={formRef}
            form={form1}
            onValuesChange={handleFormChange}
          >
            <Row gutter={10} style={{ marginLeft: "3rem", paddingTop: "2rem" }}>
              <Col xs={24} sm={12} md={10} lg={4} xl={4}>
                <Form.Item
                  name="div_name"
                  rules={[
                    {
                      required: true,
                      message: "Name is required",
                    },
                  ]}
                >
                  <Input placeholder="Name" name="div_name" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={10} lg={4} xl={4}>
                <Form.Item name="div_level" initialValue={namingData.div_label}>
                  <Input placeholder="level" name="div_level" disabled />
                </Form.Item>
              </Col>
              <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                <Form.Item
                  name="div_id"
                  rules={[
                    {
                      validator: checkUserExists,
                      validateTrigger: "onChange",
                    },
                  ]}
                >
                  <Input placeholder="hireracy id" name="div_id" />
                </Form.Item>
              </Col>
              <Col xs={3} sm={3} md={3} lg={2} xl={2}>
                <Form.Item name="structure">
                  <Input
                    placeholder="structure"
                    name="structure"
                    style={{ display: "none" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={2} sm={2} md={2} lg={3} xl={3}>
                <Form.Item name="users">
                  <Input
                    placeholder="User"
                    name="users"
                    style={{ display: "none" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                <Form.Item name="manager">
                  <Select placeholder="Manager" name="manager">
                    {manager?.map((app) => (
                      <Option key={app.id} value={app.id}>
                        {app.full_name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                <Form.Item>
                  <div>
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{
                        background: "transparent",
                        border: "none",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            width: "1.8rem",
                            height: "1.8rem",
                            borderRadius: "50%",
                            backgroundColor: "#52c41a",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <CheckOutlined
                            title="submit"
                            style={{
                              color: "#fff",
                              fontSize: "1.2rem",
                              fontWeight: "700",
                            }}
                          />
                        </div>
                      </div>
                    </Button>
                    <DeleteTwoTone
                      style={{
                        cursor: "pointer",
                        fontSize: "1.7rem",
                        marginLeft: "0.9rem",
                      }}
                      title="delete"
                      twoToneColor="#eb2f96"
                      onClick={() => {
                        // setNewProductRowIndex(-1);

                        dispatch(setFirstTable({ index: index, value: false }));
                        // handleReset();
                      }}
                    />
                  </div>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          {/* <DeactivationModal
            visible={modalVisible}
            onCancel={handleCancelModal}
            onDeactivate={handleDeactivation}
            record={selectedRecord}
            setRecord={setSelectedRecord}
            name={selectedRecord ? selectedRecord.entity_name : ""}
            level="level2"
          /> */}
        </div>
      )}
    </>
  );
};
export default ExpanedFirstRow;
